import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import * as actions from 'data/redux/actions'

import { LoadingIndicator } from 'basecomps'
import { useUser, useGame } from 'data/hooks'

export const GameLoader = ({onLoaded}) => {

  const gameId = useParams().gameId || playmotiv.game.gameId
  const { game, loaded, refresh } = useGame(gameId)

  useEffect(() => {

    if (!game) return
    if (!loaded) return
    if (loaded) onLoaded(true)

  }, [game, loaded])

  useEffect(() => {

    gameId && refresh()

  }, [gameId])

  return <LoadingIndicator text="Cargando partida ..." />
}
